import React from 'react';
import QuotedNotSoldData from './QuotedNotSoldData';
import { ITileActivityTab, TwoTabTile } from 'Feature/PageContent/TwoTabTile/TwoTabTile';
import RichText from 'Feature/PageContent/Shared/Tiles/RichText';
import './QuotedNotSold.scss';
import { ErrorBoundary } from 'react-error-boundary';
import { HandleErrorBoundaryCatch } from 'Utilities/ErrorHelper';
import { getClientList } from 'Foundation/Configurations/GlobalConfiguration';

interface IQuotedNotSoldTile {
  tileTitle: string | null;
  tileHeaderURL: string | null;
  tileLinkText: string | null;
  tileLinkTarget: string | null;
  tileLinkAltText: string | null;
  qnsTabTitle: string | null;
  qnsTabTitlePopoverText: string | null;
  qnsNoDataRichText: string | null;
  richTextTabTitle: string | null;
  richTextTabTitlePopoverText: string | null;
  richTextTabContent: string | null;
  richTextTabHideAsOfDate: boolean | null;
}

const QuotedNotSold: React.FunctionComponent<IQuotedNotSoldTile> = (props) => {
  const [hideQNSFooterDate, setHideQNSFooterDate] = React.useState<boolean>(false);
  const defaultQnsTabTitle = 'Preferred Quotes';
  const qnsTabTitleToRender = props?.qnsTabTitle !== null && props.qnsTabTitle !== undefined && props.qnsTabTitle.length > 0 
    ? props.qnsTabTitle 
    : defaultQnsTabTitle;
  const getFooterDate = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday.toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' });
  };

  const handleHideQNSFooterDateChange = (hideQNSFooterDate: boolean) => {
    setHideQNSFooterDate(hideQNSFooterDate);
  };

  const tabs: ITileActivityTab[] = props
    ? props.qnsTabTitle !== null && props.qnsTabTitle !== undefined && props.qnsTabTitle.length > 0
      ? [
          {
            title: qnsTabTitleToRender,
            titlePopoverText: props.qnsTabTitlePopoverText,
            hideAsOfDate: hideQNSFooterDate,
            body: <QuotedNotSoldData qnsNoDataRichText={props.qnsNoDataRichText} setHideQNSFooterDate={handleHideQNSFooterDateChange} />,
            footer: !hideQNSFooterDate ? <div className="tile-footer-date">Last 2 weeks ({getFooterDate()})</div> : null,
            tabClassName: 'quoted-not-sold-tab',
          },
          {
            title: props.richTextTabTitle,
            hideAsOfDate: props.richTextTabHideAsOfDate,
            body: <RichText className="two-tab-tile-tab-2-richtext" content={props.richTextTabContent ?? ''} />,
            footer: <div className="tile-footer-date">As of ({getFooterDate()})</div>,
          },
        ]
      : [
          {
            title: defaultQnsTabTitle,
            hideAsOfDate: true,
            body: <QuotedNotSoldData/>,
            tabClassName: 'quoted-not-sold-tab-error',
          },
        ]
    : [];

  return (
    <ErrorBoundary fallback={<HandleErrorBoundaryCatch component={"QuotedNotSold"} message={"QuotedNotSold render error"} />}>
      <TwoTabTile
        tileTitle={props?.tileTitle && props.tileTitle?.length > 0 ? props.tileTitle : 'My production'}
        tileLinkURL={props?.tileHeaderURL && props.tileHeaderURL?.length > 0 ? props.tileHeaderURL : getClientList() ?? ''}
        tileLinkText={props?.tileLinkText && props.tileLinkText?.length > 0 ? props.tileLinkText : 'See all quotes'}
        tileLinkTarget={props?.tileLinkTarget && props.tileLinkTarget?.length > 0 ? props.tileLinkTarget : '_blank'}
        tileLinkAltText={props?.tileLinkAltText && props.tileLinkAltText?.length > 0 ? props.tileLinkAltText : 'See all quotes'}
        hideAgencyCode={true}
        tabs={tabs}
      />
    </ErrorBoundary>
  );
};

export default QuotedNotSold;
